import { makePost, makeGet, makeGetWithParam } from './ServiceManager';

export const insertTag = async (tag) => {
  const result = await makePost('service/tags/tag', { tag });
  return result;
};

export const getTags = async (createdBy) => {
  const result = createdBy
    ? await makeGetWithParam(
        'service/tags/tags',
        null,
        `?created_by=${encodeURIComponent(createdBy)}`
      )
    : await makeGet('service/tags/tags');
  return result;
};

export const getFormattedTags = async (createdBy) => {
  const result = createdBy
    ? await makeGetWithParam(
        'service/tags/all',
        null,
        `?created_by=${encodeURIComponent(createdBy)}`
      )
    : await makeGet('service/tags/all');
  return result;
};

export const getTagsByCategory = async (category) => {
  const result = await makeGetWithParam(
    'service/tags/category',
    null,
    category
  );
  return result;
};

export const getTagsForCategories = async (categories, createdBy) => {
  const result = await makePost('service/tags/categories', {
    categories,
    createdBy
  });
  return result;
};

export const getTagsForDashboard = async (dashboardId) => {
  const result = await makeGetWithParam(
    'service/tags/dashboard',
    null,
    dashboardId
  );
  return result;
};

export const getTagsForDashboards = async (dashboardIds) => {
  const result = await makePost('service/tags/dashboards', {
    dashboardIds
  });
  return result;
};



// WEBPACK FOOTER //
// ./src/services/TagService.js